export const SET_GYROSCOPE = "SET_GYROSCOPE";

export const setGyroscope = (payload) => (dispatch) => {
  return dispatch({ type: SET_GYROSCOPE, payload });
};
